import { render, staticRenderFns } from "./DiccionarioMilitarPage.vue?vue&type=template&id=779c29d0"
import script from "./DiccionarioMilitarPage.js?vue&type=script&lang=js&external"
export * from "./DiccionarioMilitarPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports